export function createTypedAnswerProvider(getText) {
  return async function getAnswer() {
    return {
      text: String(getText?.() || "").trim(),
      audioBlob: null,
    };
  };
}
